import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/flhas")({
  beforeLoad: () => {
    throw redirect({ to: "/my-flhas" });
  },
  component: () => null,
});
